<template>
	<div class="main" v-loading="list_loading">
		<mybread></mybread>
		<el-table :data="userList" border style="width: 100%">
			<el-table-column prop="id" label="id" width="80">
			</el-table-column>
			<el-table-column prop="business" label="企业名称">
			</el-table-column>
			<el-table-column prop="username" label="用户名">
			</el-table-column>
			<el-table-column prop="phone" label="手机号">
			</el-table-column>
			<el-table-column label="状态">
				<template scope="scope">
					<span v-if="scope.row.status=== 1" style="color:red">未审核</span>
					<span v-else style="color:#67C23A">已审核</span>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="warning" @click="handleEdit( scope.row)" icon="el-icon-edit">编辑</el-button>
					<el-button size="mini" type="danger" @click="handleDelete(scope.row)" icon="el-icon-delete">删除</el-button>
					<el-button size="mini" type="success" @click="handleCheck(scope.row)" icon="el-icon-s-check">审核</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" background @size-change="handleSizeChange" :page-sizes='[5,10,20]' :page-size='pageSize' layout="sizes,prev, pager, next,total,jumper" :total="total">
			</el-pagination>
		</div>
		<el-dialog title="编辑用户列表" :visible.sync="add_dv" width="30%">
			<user-edit ref="addUserListForm"></user-edit>
			<span slot="footer" class="dialog-footer">
				<el-button @click="add_dv = false">取 消</el-button>
				<el-button type="primary" @click="addUser">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	// import userDetail from "./user-detail/user_detail.vue"
	import userEdit from "./user-detail/user_edit.vue"
	import mybread from "@/components/bread"
	// import userAdd from "./user-detail/user_add.vue"
	export default {
		components: {
			// userDetail,
			userEdit,
			mybread
			// userAdd,
		},
		inject: ['reload'],
		data() {
			return {
				total: 0, //总页数
				pageSize: 10, //每页条数
				currentPage: 1, //当前页（默认第一页）
				detail_dv: false,
				detail_loading: false,
				dialogUserInfo: [], //父组件
				add_dv: false,
				add_dv1: false,
				userList: [],
				list_loading:true
			}
		},
		created() {
			this.getUserList()
		},


		methods: {
			handleCheck(row) { //审核
				this.$confirm('是否审核?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					const data = {
						id: row.id,
						username: row.username,
						password: row.password,
						phone: row.phone,
						status: row.status
					}
					this.$post("api/user/audit", data).then(res => {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getUserList()
					}).catch((e) => {
						window.console.log(e)
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},

			getUserList() { //列表数据
				const data = {
					length: this.pageSize,
					start: (this.currentPage - 1) * this.pageSize,
					roleId: 13
				}
				this.$get("api/user/listData", data).then(res => {
					this.userList = res.data
					this.total = res.recordsFiltered
					this.list_loading=false

				}).catch((e) => {
					window.console.log(e)
				})

			},



			handleEdit(row) { //编辑调接口获取table行里数据的方法
				this.isEdit = true
				this.add_dv = true

				this.$post("api/user/detail/" + row.id).then(res => {
					this.$refs.addUserListForm.form = res.data

				}).catch((e) => {
					window.console.log(e)
				})

				this.add_dv = true
			},

			// handleEdit(row) {//编辑不调接口获取table行里数据的方法
			// 	this.isEdit = true
			// 	this.add_dv = true
			// this.$nextTick(() => {
			// 	this.$refs.addUserListForm.form = Object.assign({}, row);
			// });
			// },
			addUser() { //编辑
				this.$refs.addUserListForm.$refs.frmAdd.validate((valid) => {
					if (valid) {
						let formDate = this.$refs.addUserListForm.form
						const data = {
							id: formDate.id,
							business: formDate.business,
							username: formDate.username,
							password: formDate.password,
							phone: formDate.phone,
							status: formDate.status
						}
						this.$post("api/user/update", data).then(res => {
							var isSuccess = res.success
							if (isSuccess == 1) {
								this.$message({
									message: '保存成功！',
									type: 'success'
								});
								this.getUserList()
							} else {
								this.$message({
									message: '保存失败！',
									type: 'error'
								});
							}
							this.add_dv = false

						}).catch((e) => {
							window.console.log(e)
						})

					} else {
						return this.$message({
							message: '请完整填写信息！',
							type: 'warn'
						})
					}
				})
			},
			handleDelete(row) { //删除
				this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$post("api/user/delete/" + row.id).then(res => {
						let totalPage = Math.ceil((this.total - 1) / this.pageSize)
						let currentPage = this.currentPage > totalPage ? totalPage : this.currentPage
						this.currentPage = currentPage < 1 ? 1 : currentPage

						var isSuccess = res.success
						if (isSuccess == 1) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getUserList()
						}

					}).catch((e) => {
						window.console.log(e)
					})


				})
			},
			handleCurrentChange(val) {
				this.currentPage = val; //获取当前页
				this.getUserList();
				// window.console.log(`当前页: ${val}`);
			},
			handleSizeChange(psize) { //选择每页条数
				this.pageSize = psize;
				this.getUserList();
			},


		}
	}
</script>

<style scoped="scoped">
	.main {
		background: #fff;
		padding: 0 20px 20px 20px;
	}

	.add-btn {
		margin-bottom: 20px;
	}

	.add-btn .el-button {
		font-size: 16px;
	}

	.block {
		text-align: center;
		margin-top: 20px;
	}
</style>
